<template>
    <PlanbordGridRow sticky>
        <PlanbordGridLeftDataColumns>
            <PlanbordGridCell header centeredVertically>Medewerker</PlanbordGridCell>
            <PlanbordFunctionCell header centeredVertically>Functies</PlanbordFunctionCell>
            <PlanbordCommentCell header centeredVertically>Opmerkingen</PlanbordCommentCell>
            <PlanbordStampStartDateCell header centeredVertically>Startdatum stempelfase</PlanbordStampStartDateCell>
        </PlanbordGridLeftDataColumns>
        <PlanbordHeaderCell
            v-for="(day, index) in roster.days"
            :key="index"
            :day="day"
            :index="index"
            :roster="roster"
            :enabledWorkSchedule="enabledWorkSchedule"
            :workSchedulePositions="workSchedulePositionsPerDay[day.formattedForComputers] ?? []"
            @open:workSchedule="$emit('open:workSchedule', $event)"
        />
        <PlanbordGridRightDataColumns>
            <BalanceHead
                :timeTypes="roster.timeTypes"
                :deploymentCountConfigurations="deploymentCountConfigurations"
                :enabledBalanceAndCountDisplays="enabledBalanceAndCountDisplays"
                :leaveOverviews="leaveOverviews"
            />
        </PlanbordGridRightDataColumns>
    </PlanbordGridRow>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import PlanbordHeaderCell from '@/components/Planbord/PlanbordHeaderCell.vue';
    import BalanceHead from '@/components/Planbord/Balance/BalanceHead.vue';
    import {RosterData} from '@/types/types';
    import {BalanceFilterType} from '@/components/FilterBar/types';
    import {LeaveOverview, DeploymentCountConfiguration} from '@cquential/api';
    import PlanbordGridRow from '@/components/Planbord/PlanbordGridRow.vue';
    import PlanbordGridLeftDataColumns from '@/components/Planbord/PlanbordGridLeftDataColumns.vue';
    import PlanbordGridRightDataColumns from '@/components/Planbord/PlanbordGridRightDataColumns.vue';
    import PlanbordFunctionCell from '@/components/Planbord/PlanbordFunctionCell.vue';
    import PlanbordCommentCell from '@/components/Planbord/PlanbordCommentCell.vue';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';
    import {PlanbordWorkSchedulePosition} from '@/types/api-object-extensions';
    import PlanbordStampStartDateCell from '@/components/Planbord/PlanbordStampStartDateCell.vue';

    @Component({
        components: {
            PlanbordHeaderCell,
            BalanceHead,
            PlanbordGridRow,
            PlanbordGridLeftDataColumns,
            PlanbordGridRightDataColumns,
            PlanbordFunctionCell,
            PlanbordCommentCell,
            PlanbordGridCell,
            PlanbordStampStartDateCell,
        },
        emits: ['open:workSchedule'],
    })
    export default class PlanbordHeader extends Vue {
        @Prop({required: true}) public roster!: RosterData;
        @Prop({required: true}) public enabledBalanceAndCountDisplays!: Record<BalanceFilterType, Record<number, boolean>>;
        @Prop({required: true}) public leaveOverviews!: LeaveOverview[];
        @Prop({required: true}) public deploymentCountConfigurations!: DeploymentCountConfiguration[];
        @Prop({type: Boolean}) public enabledWorkSchedule!: boolean;
        @Prop({required: true}) public workSchedulePositionsPerDay!: Record<string, PlanbordWorkSchedulePosition[]>;
    }
</script>
